// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"43582c24","184":"7f102a16","426":"975840af","703":"a6c83c68"}[chunkId] + ".chunk.js";
};